import FDictionary from '../__select';

export default class FDictionaryManager extends FDictionary {
  dictionary = 'user';
  setOptions(options = []) {
    this.options = options;
    // console.log(options);
    // if (this.value && !this.options.find(i => i.value === this.value.value)) {
    //   this.value = null;
    // }
  }
}
